import React from 'react';
import styles from '../../css/primereact/resources/themes/tailwind-light/theme.module.css';

const Contact = () => {
  return <h1 className={styles["p-component"]} style={{textDecorationLine: 'Underline', textAlign: 'center'}}>sujithkp@yahoo.com</h1>;
};

export default Contact;
